import { useTheme } from '@mui/material'
import { useContextState } from '../../../../../../../../../../hooks/theme'

export const useStyles = () => {
  const { colors: color } = useContextState()
  const { breakpoints } = useTheme()
  return {
    container: {
      /* paddingTop: '40px',
      paddingRight: '40px', */
      /* paddingLeft: '1px',
      paddingBottom: '15px', */
      width: '100%',
      overflowY: 'auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom : '20px',
    },
    headerLeft: {
      width: 'fit-content',
    },
    stepper: {
      width: {xl: '500px', lg: 'min-content', md: 'min-content', sm: 'min-content'},
      [breakpoints.between(1450, 1700)]: {
        width: '500px'
      }
    },
    body: {
      margin: '20px 0',
      width: '100%',
      minHeight: '10rem',
    },
    buttonsContainer: (flag:boolean) => ({
      display: 'flex',
      width: '100%',
      justifyContent: flag ? 'space-between' : 'end',
      alignItems: 'center',
      '& .back': {
        width: '80px',
        height: '36px',
      },
      '& .next': {
        borderRadius: '4px',
      }
    }),
    containerFinal: {
      height: '300px', 
      width: '100%', 
      display:'flex',
      flexDirection:'column',
      gap:1,
      alignItems: 'center', 
      justifyContent: 'center',
      '& .continue': {
        borderRadius: '4px',
        marginTop:2
      },
    },
    arrow:{
      marginLeft: '-30px'
    },
    title: {
      flexGrow: 1,
      fontSize: '22px',//20
      fontWeight: '500',
    },
    icon: {
      '& .MuiSvgIcon-root':{
          width: '3em',
          height: '3em',
          color: color.color4
      }
  },
  }
}
